import { getHeaders } from "../request-headers.ts";
import type {
  GetWechatJssdkSignatureParams,
  HandleWechatServiceAccountCallbackParams,
  VerifyWechatServiceAccountCallbackParams,
  WechatJssdkSignatureResponse,
  WechatServiceAccountMenuMutationResponse,
  WechatServiceAccountMenuRequest,
  WechatServiceAccountSnapshot,
} from "../../model";

import { cnapexApiFetch } from "../../../fetcher.ts";

export const getAdminGetWechatServiceAccountSnapshotUrl = () => {
  return `/api/admin/wechat/service-account`;
};

export const adminGetWechatServiceAccountSnapshot = async (
  options?: Parameters<typeof cnapexApiFetch>[1],
): Promise<WechatServiceAccountSnapshot> => {
  return cnapexApiFetch<WechatServiceAccountSnapshot>(
    getAdminGetWechatServiceAccountSnapshotUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminPublishWechatServiceAccountMenuUrl = () => {
  return `/api/admin/wechat/service-account/menu`;
};

export const adminPublishWechatServiceAccountMenu = async (
  wechatServiceAccountMenuRequest: WechatServiceAccountMenuRequest,
  options?: Parameters<typeof cnapexApiFetch>[1],
): Promise<WechatServiceAccountMenuMutationResponse> => {
  return cnapexApiFetch<WechatServiceAccountMenuMutationResponse>(
    getAdminPublishWechatServiceAccountMenuUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
      body: JSON.stringify(wechatServiceAccountMenuRequest),
    },
  );
};

export const getAdminDeleteWechatServiceAccountMenuUrl = () => {
  return `/api/admin/wechat/service-account/menu/delete`;
};

export const adminDeleteWechatServiceAccountMenu = async (
  options?: Parameters<typeof cnapexApiFetch>[1],
): Promise<WechatServiceAccountMenuMutationResponse> => {
  return cnapexApiFetch<WechatServiceAccountMenuMutationResponse>(
    getAdminDeleteWechatServiceAccountMenuUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getGetWechatJssdkSignatureUrl = (params?: GetWechatJssdkSignatureParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/wechat/jssdk/signature?${stringifiedParams}`
    : `/api/wechat/jssdk/signature`;
};

export const getWechatJssdkSignature = async (
  params?: GetWechatJssdkSignatureParams,
  options?: Parameters<typeof cnapexApiFetch>[1],
): Promise<WechatJssdkSignatureResponse> => {
  return cnapexApiFetch<WechatJssdkSignatureResponse>(getGetWechatJssdkSignatureUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getVerifyWechatServiceAccountCallbackUrl = (
  params?: VerifyWechatServiceAccountCallbackParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/wechat/service-account/callback?${stringifiedParams}`
    : `/api/wechat/service-account/callback`;
};

export const verifyWechatServiceAccountCallback = async (
  params?: VerifyWechatServiceAccountCallbackParams,
  options?: Parameters<typeof cnapexApiFetch>[1],
): Promise<void> => {
  return cnapexApiFetch<void>(getVerifyWechatServiceAccountCallbackUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getHandleWechatServiceAccountCallbackUrl = (
  params?: HandleWechatServiceAccountCallbackParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/wechat/service-account/callback?${stringifiedParams}`
    : `/api/wechat/service-account/callback`;
};

export const handleWechatServiceAccountCallback = async (
  handleWechatServiceAccountCallbackBody: string,
  params?: HandleWechatServiceAccountCallbackParams,
  options?: Parameters<typeof cnapexApiFetch>[1],
): Promise<void> => {
  return cnapexApiFetch<void>(getHandleWechatServiceAccountCallbackUrl(params), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/xml", ...getHeaders(options?.headers) },
    body: JSON.stringify(handleWechatServiceAccountCallbackBody),
  });
};
